import Collapse from '@mui/material/Collapse';
import { ICollapsibleSubNavigationProps } from './CollapsibleSubNavigation.interface';

export const CollapsibleSubNavigation = <T,>(props: ICollapsibleSubNavigationProps<T>) => {
  const { items, basePath, depth, isNestedNavigationExpanded, SubNavigationComponent } = props;

  return (
    <Collapse in={isNestedNavigationExpanded} timeout={'auto'} unmountOnExit={true}>
      <SubNavigationComponent
        items={items}
        basePath={basePath}
        depth={depth}
      />
    </Collapse>
  );
};
